import React from 'react';
import './loading.scss';

const Loading = () => {
  return (<div className="spinner"></div>);
}

export default Loading;